@if (state$ | async; as state) {
  @if (state.mode !== 'hidden') {
    <div
      class="sml-fs-overlay"
      [class.sml-fs-overlay--result]="state.mode !== 'submitting'"
      role="status"
      aria-live="polite"
    >
      <!-- shared soft aurora backdrop -->
      <div class="sml-fs-backdrop"></div>

      <!-- celebratory confetti behind the result (matches the AI success overlay) -->
      @if (state.mode === 'success') {
        <div class="sml-fs-confetti-screen sml-fs-confetti-screen--back" aria-hidden="true">
          @for (p of confettiPiecesBack; track $index) {
            <i [class]="p.cls" [ngStyle]="p.style"></i>
          }
        </div>
      }

      @switch (state.mode) {
        <!-- ============================ submitting ============================ -->
        <!-- orbit loader ported from the application-payment loading spinner -->
        @case ('submitting') {
          <div class="sml-fs-stage">
            <div class="sml-fs-orbit" aria-hidden="true">
              <div class="sml-fs-orbit-ring sml-fs-orbit-ring--outer"></div>
              <div class="sml-fs-orbit-ring sml-fs-orbit-ring--mid"></div>
              <div class="sml-fs-orbit-track sml-fs-orbit-track--1"><span class="sml-fs-orbit-dot"></span></div>
              <div class="sml-fs-orbit-track sml-fs-orbit-track--2"><span class="sml-fs-orbit-dot sml-fs-orbit-dot--green"></span></div>
              <div class="sml-fs-orbit-track sml-fs-orbit-track--3"><span class="sml-fs-orbit-dot sml-fs-orbit-dot--gold"></span></div>
              <div class="sml-fs-orbit-core">
                @if (state.isPayment) {
                  <span class="sml-fs-orbit-core-symbol">$</span>
                } @else {
                  <img src="./assets/images/brand/logo-icon-navy.png" alt="SeeMyLegacy" class="sml-fs-orbit-core-logo" />
                }
              </div>
            </div>

            <div class="sml-fs-text">
              <h3 class="sml-fs-title">
                {{ submittingTitle }}<span class="sml-fs-dots" aria-hidden="true"><i>.</i><i>.</i><i>.</i></span>
              </h3>
              <p class="sml-fs-status">{{ submittingMessage }}</p>
            </div>

            <div class="sml-fs-progress" aria-hidden="true">
              <span class="sml-fs-progress-fill"></span>
            </div>
          </div>
        }

        <!-- ============================= success ============================== -->
        <!-- success visuals ported from the application-payment component -->
        @case ('success') {
          <div class="sml-fs-stage">
            <div class="sml-fs-success-icon" aria-hidden="true">
              <span class="sml-fs-success-ring sml-fs-success-ring--1"></span>
              <span class="sml-fs-success-ring sml-fs-success-ring--2"></span>
              <span class="sml-fs-success-ring sml-fs-success-ring--3"></span>
              <svg
                class="sml-fs-success-check"
                xmlns="http://www.w3.org/2000/svg"
                width="88"
                height="88"
                viewBox="0 0 88 88"
                fill="none"
              >
                <circle
                  class="sml-fs-success-check-circle"
                  cx="44"
                  cy="44"
                  r="40"
                  stroke="#5FB173"
                  stroke-width="3"
                  fill="rgba(95,177,115,0.08)"
                />
                <path
                  class="sml-fs-success-check-mark"
                  d="M28 46 L40 58 L62 34"
                  stroke="#30997A"
                  stroke-width="5"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div class="sml-fs-text sml-fs-text--result">
              <h3 class="sml-fs-title sml-fs-title--success">{{ successTitle(state) }}</h3>
              <p class="sml-fs-status sml-fs-status--result">{{ successMessage(state) }}</p>
            </div>

            <button type="button" class="sml-fs-btn" (click)="onClose()">Close</button>
          </div>
        }

        <!-- ============================== error =============================== -->
        @case ('error') {
          <div class="sml-fs-stage">
            <div class="sml-fs-badge sml-fs-badge--error" aria-hidden="true">
              <span class="sml-fs-cross">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path class="sml-fs-cross__path" d="M7 7l10 10M17 7L7 17" />
                </svg>
              </span>
            </div>

            <div class="sml-fs-text sml-fs-text--result">
              <h3 class="sml-fs-title sml-fs-title--error">{{ errorTitle(state) }}</h3>
              <p class="sml-fs-status sml-fs-status--result">{{ errorMessage(state) }}</p>
            </div>

            <button type="button" class="sml-fs-btn sml-fs-btn--error" (click)="onClose()">Close</button>
          </div>
        }
      }

      <!-- full-screen confetti raining over the success result -->
      @if (state.mode === 'success') {
        <div class="sml-fs-confetti-screen" aria-hidden="true">
          @for (p of confettiPieces; track $index) {
            <i [class]="p.cls" [ngStyle]="p.style"></i>
          }
        </div>

        <!-- pinned to the very bottom of the page -->
        <div class="sml-fs-poweredby">
          Powered by
          <img src="./assets/images/brand/see-my-legacy.svg" alt="SeeMyLegacy" class="sml-fs-poweredby__logo" />
        </div>
      }
    </div>
  }
}
